import { css } from '@emotion/core'

export default {
  container: css`
    margin-bottom: 10px;
  `,
  expanderButton: css`
    text-align: center;
    margin-top: 10px;
  `,
}
